import {
    Box,
    Mail,
    User,
    Circle,
    Shield,
    Calendar,
    FileText,
    CheckSquare,
    ShoppingCart,
    MessageSquare
  } from 'react-feather'


  export default [
    {
      id: 'conciliation',
      title: 'Conciliation',
      icon: <Shield size={20} />,
      badge: 'light-warning',
      navLink: '/conciliation'
     
    }
  ]